// ─────────────────────────────────────────────────────────────
// OFFICIAL HOMEPAGE HERO ARTWORK (owner-approved set)
// No baked-in interface — SHOP NOW, menu and product link are live HTML,
// positioned on the artwork via source-pixel anchors (scale with the image).
// Logo, headline and the technical strip are part of the artwork.
// ─────────────────────────────────────────────────────────────

export const heroArtwork = {
  desktop: {
    src: 'https://cdn.magicpatterns.com/uploads/ptTPHV3hN3UEaURGjgRyQx/CFE959D9-3AEE-4BF2-913B-7D6095776389.png',
    width: 1672,
    height: 941,
    shopNow: { x: 77, y: 442 }, // top-left of the button: under the headline waves, above the product
    product: { x: 40, y: 500, w: 420, h: 300 }, // M1 PRO + Magnetic Mount → /m1-pro
  },
  mobile: {
    src: 'https://cdn.magicpatterns.com/uploads/iyAoXpg7qd1dMy7kqUYw7V/25C5FF9D-4B53-4343-8ED0-39CBC279FB05.png',
    width: 941,
    height: 1672,
    // Button centered horizontally between the "16 Colors" and "Magnetic Mount" icons,
    // its bottom edge resting just above the technical strip.
    shopNow: { cx: 462, bottom: 1474 },
    product: { x: 40, y: 1030, w: 520, h: 330 },
  },
  alt: 'MarineForceLED — Professional-grade lighting, built for the elements. Same water, a brighter world. Miami waterfront residence at night with an illuminated pool and spa, a lit dock and the yacht Geneve. In the foreground, the M1 PRO 13-LED light glowing blue beside its Magnetic Mount System base.',
  // Owner review: 13 lenses countable; drawn layout reads as ring of 9 + 4 inner,
  // not the reference 1-3-5-3-1. Base shown beside the light (exploded side view).
  productVerified: false,
};
